<template>
<!--分配-->
    <div :class="phoneClass || 'store-list-container'">
        <content-header v-if="!phoneClass">
            <button></button>
            <el-button type="primary" class="normal-button" style="margin-right:10px;" @click="downloadTheData" v-if="user.role === 1">
                <img src="../../assets/img/btn/icon-download.png">
                <span class="text">{{$t("sideBar.DownloadTheData")}}</span>
            </el-button>
            <el-dropdown >
                <el-button type="primary" class="normal-button" style="margin-right:10px;" v-if="user.role !== 1">
                    <img src="../../assets/img/btn/icon-download.png">
                    <span class="text">{{$t("sideBar.download")}}</span>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item>
                        <span class="text" @click="downloadFile('NB')">{{$t("sideBar.downloadNB")}}</span>
                    </el-dropdown-item>
                    <el-dropdown-item>
                        <span class="text" @click="downloadFile('Lora')">{{$t("sideBar.downloadLora")}}</span>
                    </el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
            <el-dropdown >
                <el-button type="primary" class="normal-button" style="margin-right:10px;" >
                    <img src="../../assets/img/btn/icon-export.png">
                    <span class="text">{{$t("sideBar.upload")}}<i class="el-icon-arrow-down el-icon--right"></i></span>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item>
                        <el-upload style="display:inline-block;margin-right:5px;"
                                   :action="fileUrl"
                                   :on-success="onFileUploadSuccessEvent"
                                   :before-upload="beforeAvatarUpload"
                                   ref="el-upload"
                                   :show-file-list="false" :auto-upload="true">
                                <span class="text" >{{$t("sideBar.uploadNB")}}</span>
                        </el-upload>
                    </el-dropdown-item>
                    <el-dropdown-item>
                        <el-upload style="display:inline-block;margin-right:5px;"
                                   :action="fileStorageLoraUrl"
                                   :on-success="onFileUploadSuccessEvent"
                                   :before-upload="beforeAvatarUpload"
                                   ref="el-upload"
                                   :show-file-list="false" :auto-upload="true">
                            <span class="text" >{{$t("sideBar.uploadLoraStorage")}}</span>
                        </el-upload>
                    </el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>

            <el-dropdown >
                <el-button type="primary" class="normal-button" style="margin-right:10px;" >
                    <img src="../../assets/img/btn/icon-add.png">
                    <span class="text">{{$t("sideBar.newEquipment")}}<i class="el-icon-arrow-down el-icon--right"></i></span>
                </el-button>
                <el-dropdown-menu slot="dropdown">

                    <el-dropdown-item>
                        <div @click="addNewDevice(0)">新增NB设备</div>
                    </el-dropdown-item>
                    <el-dropdown-item>
                        <div @click="addNewDevice(1)">新增Lora设备</div>
                    </el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>


            <!-- <el-button type="primary" class="normal-button" @click="addNewDevice">
                <img src="../../assets/img/btn/icon-add.png">
                <span class="text">{{$t("sideBar.newEquipment")}}</span>
            </el-button> -->
        </content-header>
        <div class="store-table" >
            <div class="search-bar">
                <div class="search-left">
                    <div class="status-index">
                        <span class="top-title">{{$t('searchBar.status')}}</span>
                        <el-select v-model="searchForm.status" clearable style="width:110px;" @change="getStorageList(1)">
                            <el-option
                                    v-for="item in statusList"
                                    :key="item.value"
                                    :label="$t('selectData.storage.status.status'+item.value)"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                    <!--批次-->
                    <div class="status-index">
                        <span class="top-title">{{$t('searchBar.batch')}}</span>
                        <el-input
                                v-model="searchForm.batch"
                                :placeholder="$t('message.select')"
                                @change="getStorageList(1)"
                                style="width:110px;"
                        ></el-input>
                        <!--<el-select v-model="searchForm.status" filterable style="width:110px;" @change="getStorageList()">-->
                            <!--<el-option-->
                                    <!--v-for="item in deviceStatusList"-->
                                    <!--:key="item.label"-->
                                    <!--:label="item.label"-->
                                    <!--:value="item.value">-->
                            <!--</el-option>-->
                        <!--</el-select>-->
                    </div>
                    <div class="status-index">
                        <span class="top-title">{{$t('searchBar.dealer')}}</span>
                        <el-select v-model="searchForm.dealer" clearable style="width:130px;" @change="getStorageList(1)">
                            <el-option
                                    :placeholder="$t('message.select')"
                                    v-for="item in dealerList"
                                    :key="item.label"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="status-index">
                      <span class="top-title">{{$t('searchBar.type')}}</span>
                      <el-select v-model="searchForm.type" clearable style="width:130px;" @change="getStorageList(1)">
                        <el-option
                            :placeholder="$t('message.select')"
                            v-for="item in typeList"
                            :key="item.label"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                      </el-select>
                    </div>
                </div>
                <div class="search-right">
                    <el-input
                        :placeholder="$t('storage.find')"
                        @change="getStorageList(1)"
                        style="width:260px"
                        v-model="searchForm.key">
                        <i slot="prefix" class="el-input__icon el-icon-search"></i>
                    </el-input>
                </div>
                <div class="btns" v-if="phoneClass">
                    <el-button type="primary" @click="getStorageList(1)">{{$t("devicePage.search")}}</el-button>
                    <el-button @click="initStorageList()">{{$t("devicePage.reset")}}</el-button>
                </div>
            </div>

            <div class="table-outer" >
                <el-table :data="storageList" :header-cell-style="{background:'#fafbfc'}" class="normal-table" style="width: 100%">
                    <el-table-column prop="imei" min-width="150px" :label="$t('storage.imei')" ></el-table-column>
                    <el-table-column prop="model" min-width="160px" :label="$t('storage.type')"></el-table-column>
                    <el-table-column prop="type" min-width="160px" :label="$t('storage.genre')">
                      <div class="table-outer-status" slot-scope="scope">
                        {{scope.row.type | deviceType()}}
                      </div>
                    </el-table-column>
                    <el-table-column prop="batch" :label="$t('storage.batch')"></el-table-column>
                    <el-table-column prop="is_active" min-width="80px" :label="$t('storage.activationOrNot')">
                        <template slot-scope="scope" >
                            <span v-if="scope.row.is_active" style="color: #0AC47A">{{$t('storage.yes')}}</span>
                            <span v-else >{{$t('storage.no')}}</span>
                            <!--{{scope.row.is_active ? '是' : '否'}}-->
                            <!-- 0:未激活 1:激活 -->
                        </template>
                    </el-table-column>
                    <el-table-column prop="agent" min-width="90px" :label="$t('storage.serviceProviders')"></el-table-column>
                    <el-table-column min-width="180px" v-if="user.role === 1" prop="company" :label="$t('storage.customers')"></el-table-column>
                    <el-table-column label="操作" fixed="right" width="90"  >
                        <div slot-scope="scope" class='my-table-button'>
                            <img src="../../assets/img/btn/edit.png" @click="registerDevice(scope.row)" v-if="scope.row.type === 0">
                            <img src="../../assets/img/btn/delete.png" @click="deleteDevice(scope.row)">
                        </div>
                    </el-table-column>
<!--                    <el-table-column label="操作" fixed="right" width="100"  v-if="false">
                        <div slot-scope="scope" class='my-table-button'>
                            <img src="../../assets/img/btn/edit.png" @click="editDevice(scope.row)">
                            <img src="../../assets/img/btn/delete.png" @click="deleteDevice(scope.row)">
                        </div>
                    </el-table-column>-->
                </el-table>
            </div>

            <div class="pagination" v-if="storageList[0]" style="text-align:right;padding:20px;">
                <el-pagination
                    @current-change="pageChange"
                    :current-page="currentPage"
                    :page-size="pageSize"
                    layout="total, prev, pager, next"
                    :total="total"
                    background>
                </el-pagination>
            </div>
        </div>
        <el-dialog @closed="closeDialog" :visible.sync="dialogVisible" title="设备入库" width="520px">
            <div class="dialog-content">
                <template v-if="dialogType === 0" >
                    <el-form label-position="left" label-width="70px" :model="addForm">
                        <el-form-item :label="$t('storage.imei')">
                            <el-input v-model="addForm.sn"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('storage.type')">
                            <el-input v-model="addForm.model" ></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('storage.batch')">
                            <el-input v-model="addForm.batch"></el-input>
                        </el-form-item>
                    </el-form>
                </template>
                <template v-else>
                    <el-form label-position="left" label-width="100px" :model="addForm">
                        <el-form-item :label="$t('storage.deveui')">
                            <el-input v-model="addForm.imei"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('storage.addr')">
                            <el-input v-model="addForm.addr"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('storage.nwks_key')">
                            <el-input v-model="addForm.nwks_key"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('storage.apps_key')">
                            <el-input v-model="addForm.apps_key"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('storage.type')">
                            <el-input v-model="addForm.model" ></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('storage.batch')">
                            <el-input v-model="addForm.batch"></el-input>
                        </el-form-item>
                    </el-form>
                </template>
            </div>
            <div slot="footer" class="dialog-footer" >
                <span></span>
                <div class="footer-right">
                     <el-button class="footer-button ok" type="primary" @click="saveDevice">保存</el-button>
                     <el-button class="footer-button cancel" @click="dialogVisible = false">取消</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>


<script>
import Core from "core/core";
import contentHeader from '../../components/content-header'
import {refresh} from "core/winSize"
export default {
    data() {
        return {
	        phoneClass: '',
            user: '',
            storageList: [],
            currentPage: 1,
            pageSize: 10,
            total: 0,
            searchForm: {
                key: '',
                status: '',
                site: '',
                dealer: '',
                batch: '',
                type: ''
            },
            addForm: {
                sn: '',
                model: '',
                batch: '',
                emei: '',
                addr: '',
                deveui: '',
                nwks_key: '',
                apps_key: '',
                id: 0
            },
            deviceStatusList: [
                {label: '全部',value: 0}
            ],
            statusList: Core.Const.storageStatus,
            typeList: Core.Const.storageTypeList,
            dealerList: [],

            dialogType: 0, // 新增设备类型 0:NB, 1:Lora
            dialogVisible: false, // 新增设备弹窗

            fileUrl: '',
            fileStorageLoraUrl: '',
            loading: '',
            lookToken: false        //
        };
    },
    components: {
        contentHeader
    },
	created(){
		refresh(this,'phoneClass-store-list-container');
		window.onresize = function(){
			setTimeout(function(){
				refresh(this,'phoneClass-store-list-container');
			},10)
		};
		// this.getDealerList()
		this.currentPage=1
	},
    mounted() {
        let token = Core.Data.getToken()
        // console.log(Core.Data.getUser());
        // if (this.phoneClass) {
            // this.$router.replace("/setting")
        // }
        this.user = Core.Data.getUser()
        if(this.user.role === 1){
            this.fileUrl=Core.Const.NET.IMPORT_FILE + 'import-storage-with-agent'
        } else if (Core.Data.getUser().role === 2) {
            this.fileUrl=Core.Const.NET.IMPORT_FILE + 'import-storage'
        }
        this.fileStorageLoraUrl = Core.Const.NET.IMPORT_FILE + 'import-storage-lora?token=' + token
        console.log("this.fileStorageLoraUrl", this.fileStorageLoraUrl)
        console.log("this.IMPORT_FILE", Core.Const.NET.IMPORT_FILE)
        this.getStorageList();
        this.getDealerList();
    },
    computed: {
    },
    methods: {
        check(){
            if(typeof (this.addForm.model) == 'number'){
                console.log(1);
            } else (
                console.log(2)
            )
        },
        goDeviceEdit() {
        },
        /**显示新增设备弹窗 */
        addNewDevice(type = 0) {
            this.dialogType = type;
            this.dialogVisible = true;
        },
        /**关闭新增设备弹窗 */
        closeDialog() {
            this.dialogVisible = false;
            Object.keys(this.addForm).forEach(key => {
                this.addForm[key] = key === 'id' ? 0 : '';
            });
        },
        saveDevice() {
            if(this.dialogType === 0) this.saveNBDevice();
            if(this.dialogType === 1) this.saveLoraDevice();
        },
        /**新增NB设备 */
        saveNBDevice() {
            if (this.addForm.sn && this.addForm.model && this.addForm.batch) {
                Core.Api.Storage.create(this.addForm.id,this.addForm.sn,this.addForm.model,this.addForm.batch)
                    .then(res => {
                        this.$message.success('保存成功');
                        this.getStorageList();
                    })
                    .catch( e => {})
                this.closeDialog();
            } else {
                this.$message.error('请将数据填写完整！');
            }
        },
        /**新增Lora设备 */
        saveLoraDevice() {
            let keys = ['imei', 'addr', 'nwks_key', 'apps_key', 'model', 'batch'];
            for(let i = 0; i < keys.length; i++) {
                if(!this.addForm[keys[i]]) {
                    this.$message.error('请将数据填写完整！');
                    return;
                }
            }
            Core.Api.Storage.createLora(
                this.addForm.id,
                this.addForm.imei,
                this.addForm.addr,
                this.addForm.nwks_key,
                this.addForm.apps_key,
                this.addForm.model,
                this.addForm.batch
            )
            .then(res => {
                this.$message.success('保存成功');
                this.getStorageList();
            })
            .catch( e => {})
            this.closeDialog();
        },
        getDealerList() {
            Core.Api.Agent.listAll().then(res => {
                console.log(res,'all');
                let agentList = res.agent_list;
                this.dealerList = agentList;
                this.total = res.count;
            })
        },
        initStorageList() {
            let keys = ['batch', 'dealer', 'key'];
            keys.forEach(key => {
                this.searchForm[key] = '';
            })
        },
        getStorageList(page) {
            if(page) this.currentPage = page;
            // searchForm.status
            if(this.searchForm.batch){
                if(!isNaN(this.searchForm.batch )&& this.searchForm.batch > 0){
                    console.log(this.searchForm.batch)
                    Core.Api.Storage.list(this.currentPage,this.searchForm.status,this.searchForm.batch,this.searchForm.dealer,this.searchForm.key,this.searchForm.type).then(res => {
                        console.log(res,'stroList');
                        let storageList = res.storage_list;
                        this.storageList = storageList;
                        this.total = res.count;
                        // console.log(this.storageList,'stor');

                    })
                }else{
                    console.log('不符合要求');
                    alert("请输入大于0的数字")
                }
            } else {
                setTimeout(()=>{
                    Core.Api.Storage.list(this.currentPage,this.searchForm.status,this.searchForm.batch,this.searchForm.dealer,this.searchForm.key,this.searchForm.type).then(res => {
                        console.log(res,'stroList');
                        let storageList = res.storage_list;
                        this.storageList = storageList;
                        this.total = res.count;
                        // console.log(this.storageList,'stor');

                    })
                },100)
            }

        },
        pageChange(val) {
            if (!val) {
                val=1
                console.log(val,"if");
            }
            console.log(val);

            this.currentPage = val;
            this.getStorageList();
        },
        registerDevice(row) {
          this.$confirm('您确定要重新激活该设备吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
            customClass: this.phoneClass?'message-box':''
          }).then(() => {
            Core.Api.Storage.register(row.id).then(res => {
              this.$message.success('激活成功');
              this.getStorageList();
            })
          })
        },
        deleteDevice(row) {
            this.$confirm('您确定要删除该设备吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                customClass: this.phoneClass?'message-box':''
            }).then(() => {
                Core.Api.Storage.deleteLora(row.id).then(res => {
                    this.$message.success('删除成功');
                    this.getStorageList();
                })
            })
        },
        editDevice(row) {
            if(!row.id) {
                return
            }
            this.$router.push(`/device/detial?device_id=${row.id}`)
        },
        onFileUploadSuccessEvent(res, file, fileList){
                if (res.data.fail_list[0]) {
                    let msg = ''
                    for(let i in res.data.fail_list) {
                        let item = res.data.fail_list[i]
                        item.imei ? msg += 'Excel表格第'+item.row_num+'行，'+ Object.keys(item)[1] +':'+item.imei+'，'+item.message+'</br>'
                            : msg += 'Excel表格第'+item.row_num+'行，' + Object.keys(item)[1] + ': &nbsp;&nbsp; ，'+item.message+'</br>'
                        // : msg += '第'+item.row_num+'行，'+item.message+'</br>'
                        // msg += '第'+item.row_num+'行，编号:'+item.imei+'，'+item.message+'</br>'
                    }
                    let div = '<div style="min-height:300px;height:50vh;overflow: auto">' + msg + '</div>'
                    this.$alert(div, '部分设备未导入原因：', {
                        dangerouslyUseHTMLString: true
                    });
                } else {
                    this.$message.success('导入成功');
                }
                this.getStorageList();

            console.log(file,'res')
            this.loading.close();
        },
        beforeAvatarUpload(file){
            console.log(file.name.substr(file.name.lastIndexOf(".")),'文件格式')
            let EXCEL = file.name.substr(file.name.lastIndexOf("."))
            let isEXCEL  = EXCEL === '.xls' || EXCEL === '.xlsx'
            if (isEXCEL){
                this.loading= this.$loading({
                    lock: true,
                    text: 'Up loading'
                })
            } else {
                this.$message.error('请导入正确EXCEL表格（xls文件或xlsx文件）')
                return isEXCEL;
            }
        },
        downloadFile(type) {
            let user = Core.Data.getUser();
            const lang = Core.Data.getLang() || 'zh'
            console.log(user);
            if (user.role === 2 && type === "NB") {
                window.open(`/template/${lang}/storage-excel-template.xlsx`);
            } else if (user.role === 2 && type === "Lora") {
                window.open(`/template/${lang}/storage-lora-excel-template.xlsx`);
            }

        },
        downloadTheData() {
            let token=Core.Data.getToken();
            let user = Core.Data.getUser();
            console.log(user);
            if (user.role === 1){
                window.open(Core.Const.NET.END_POINT + '/storage/export-storage-device?token=' + token);
            }
        }
    },


};
</script>

<style scoped lang="scss">
@import '../../assets/style/mixin.scss';
.store-list-container {
    background-color: #E5EBEF;
    height: 100%;
    .store-table {
        margin: 30px 40px;
        background-color: #FFFFFF;
        .search-bar {
            @include flex-sb;
            padding: 20px;
            .status-index {
                margin-right: 12px;
                &:last-child {
                    margin-right: 0;
                }
            }
        }
        .table-outer {
            padding: 0 20px;
        }
    }
    .store-table-else {
        position: absolute;
        top: 60%;
        left: 50%;
        transform: translateX(-50%);
    }
    .normal-button {
        background-color: transparent;
        border-color: #FFFFFF;
        img {
            width: 13px;
            height: 13px;
            vertical-align: middle;
        }
        .text {
            font-size: 14px;
            color: #FFFFFF;
            vertical-align: middle;
            margin-left: 8px;
            line-height: 20px;
        }
    }
}
.dialog-content {
    padding: 20px 40px 10px;
}
.dialog-footer {
    padding: 10px 20px;
    border-top: 1px solid #E5EBEF;
}
</style>

<style lang="scss">
    .store-table{
            .status-index .el-input__inner{
                border-top-left-radius: 0;
                border-bottom-left-radius: 0;
            }
            .search-left {
                display: flex;
                align-items: flex-start;
                .status-index {
                    display: flex;
                    align-items: flex-start;
                }
            }
    }
    .store-list-container {
        .table-outer {
            .cell {
                white-space:nowrap;
                overflow:hidden; //超出的文本隐藏
                text-overflow:ellipsis; //溢出用省略号显示
            }
            .cell:hover {
                /*background: #e2e2e2;*/
                white-space: normal;
                overflow: visible; //超出的文本隐藏
                position: relative;
                z-index: 10000;
                text-overflow:clip;
                /*background: #f6f7fb;*/
            }
        }

    }
    .phoneClass-store-list-container {

        .phoneClass-content-header-wrapper {
            min-height: 10px;
            position: relative;
            .header-left {
                position: absolute;
                top: 3px;
            }
            .header-right {
                width: 99%;
                position: absolute;
                right: 5px;
                bottom: 3px;
                display: flex;
                justify-content: space-between;
                .el-button {
                    margin: 0 0!important;
                    padding: 5px !important;
                    min-width: 90px;
                    border-color: white;
                    background-color: #0A3D95;
                    img {
                        width: 12px;
                    }
                }
                >div {
                    margin: 0 !important;
                    >div {
                        .el-button {
                            padding: 5px 0 !important;
                            width: 70px;
                            margin: 0 3px !important;
                        }
                    }
                }
            }
        }
        .store-table {
            padding-bottom: 80px;
            .search-bar {
                padding-left: 10px;
                .search-left {
                    /*width: 300px;*/
                    display: flex;
                    flex-wrap: wrap;
                    .status-index {
                        display: flex;
                        margin-top: 10px;
                        width: 200px;
                        .el-input  {
                            width: 200px;
                            .el-input__inner {
                                width: 200px;
                            }
                        }
                    }
                }
                .search-right {
                    .el-input {
                        margin: 10px 0;
                    }
                }
                .btns {
                    margin-bottom: 8px;
                }
            }
        }

        /*页码适配移动端*/
        .pagination {
            padding: 20px 0 !important;
            text-align: center !important;
            .el-pagination {
                padding: 0;
                button {
                    width: 20px;
                    min-width: 0;
                    height: 30px;
                }
                .el-pager {
                    .number {
                        margin: 0 3px !important;
                        padding: 0 !important;
                        min-width: 0px;
                        width: 20px !important;
                        height: 30px !important;
                    }
                    .el-icon-more {

                        margin: 0 3px !important;
                        padding: 0 !important;
                        min-width: 0px;
                        width: 20px !important;
                        height: 30px !important;
                    }
                }
            }
        }
    }
</style>
